import React, { useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import SearchBar from '../SearchBar/SearchBar'
import FeatherIconWrapper from '../Icons/FeatherIconWrapper'
import ArrowIcon from '../Icons/Arrow/Arrow'
import HomeIcon from '../Icons/Home/Home'
import ProfileIcon from '../ProfileIcon/ProfileIcon'
import {
    WerfenFormFieldColor,
    WerfenFormIconBackgroundColor,
    WerfenFormIconColor,
    WerfenFormTextColor,
    White
} from '../../Constants/ColorChart'
import { setTitleBar } from "../../../actions/ui";
import { setSuggestString, setSearchString } from "../../../actions/search";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { recentActivityAPI } from "../RecentActivity/Logic/recentActivityAPI";
import { frequentlyUsedAPI} from "../RecentActivity/Logic/recentActivityAPI";
import { Title, StyledWrapper } from "./StyledTopBar";
import {
  IconContainer
} from '../ResultTable/Components/ResultRow/StyledResultRow';

/*
 *  @Description:   Component that renders a TopBar.
 */

const TopBar = ( props ) => {
    const { titleBar, visibleSearchBar, hideBackArrow } = props;
    const [activityTabBarOpen, setTabBarOpen] = React.useState( false );
    const history = useHistory();
    const handleActivity = () => {
        setTabBarOpen( !activityTabBarOpen );
    }


    useEffect( () => {
        props.setTitleBar( "" );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );
    const getRecentActivity = useCallback(() => {
        return recentActivityAPI();
    }, []);
    const getFrequentlyUsed = useCallback(() => {
        return frequentlyUsedAPI();
    }, []);


    return (
        <StyledWrapper>
            <div className="LeftButtonDiv">
                <div className="HomeButtonDiv">
                    <FeatherIconWrapper
                        className={ "HomeIcon top-bar-icon" }
                        color={ White }
                        width="40px"
                        onClick={ () => {
                            props.setSearchString("");
                            props.setSuggestString("");
                            history.push( "/" );
                        } }
                        iconStyle="stroke-width: 1.3px; &:hover{cursor: pointer}"
                        Icon={ HomeIcon }
                    />
                </div>
                {
                    visibleSearchBar === false && hideBackArrow === false &&
                    <div className={ "BackButtonDiv" }>
                        <FeatherIconWrapper
                            className={ "ArrowIcon top-bar-icon" }
                            color={ White }
                            width="30px"
                            onClick={ () => {
                                history.go( -1 );
                            } }
                            iconStyle="stroke-width: 1.3px; &:hover{cursor: pointer}"
                            Icon={ ArrowIcon }
                        />
                    </div>
                }
            </div>
            <div className="MainBarDiv">
                {
                    visibleSearchBar &&
                    <div className={"SearchBarContainer"}>
                        <SearchBar
                            placeholder="What are you looking for?"
                            iconBottom={ true }
                            background={ WerfenFormFieldColor }
                            color={ WerfenFormTextColor }
                            buttonBackgroundColor={ WerfenFormIconBackgroundColor }
                            buttonIconColor={ WerfenFormIconColor }
                            extraStyle={{height:"55px"}}
                        />
                    </div>
                }
                {
                    !visibleSearchBar &&
                    <Title className={ "Title" }>
                        { titleBar }
                    </Title>
                }
            </div>
            {
                !history.location.pathname.includes( "/profile" ) &&
                <div className="RightButtonDiv">
                    <ProfileIcon/>
                </div>
            }

        </StyledWrapper>
    )
}

const mapStateToProps = ( state ) => (
    {
        titleBar: state.ui.titleBar,
        visibleSearchBar: state.ui.visibleSearchBar,
        hideBackArrow: state.ui.hideBackArrow,
        searchString: state.search.searchString,
    });

const mapDispatchToProps = ( dispatch ) => {
    return bindActionCreators( {
        setTitleBar: setTitleBar,
        setSearchString: setSearchString,
        setSuggestString: setSuggestString,
    }, dispatch );
};

export default connect( mapStateToProps, mapDispatchToProps )( TopBar );
